/* Puff Land – script chargé par les sections concernées (dépend de theme.js) */
(() => {
  'use strict';
  const PL = window.PL;
  if (!PL || !PL.u || PL.loaded_collection) return;
  PL.loaded_collection = true;
  const { $, $$, debounce, parseHTML, storage, formatMoney, toast, trapFocus, esc, norm, num, fill, fetchProductData, productDataUrl, productBase, starsHTML, buyButton, isDesktop, reduceMotion, initWishlistButtons, applyDiscountCode, getCart, refreshCart } = PL.u;
  const S = PL.strings;
  const R = PL.routes;
  const Cart = PL.cart;
  const Compare = PL.compare;

  /* ---------- Filtres (Search & Discovery) ---------- */
  const Facets = {
    init() {
      document.addEventListener('change', (e) => {
        const t = e.target;
        const form = t.form && t.form.matches('[data-facets-form]') ? t.form : t.closest('[data-facets-form]');
        if (form && !t.matches('[data-range-min],[data-range-max]')) { this.onFormChange(form); return; }
        const sort = e.target.closest('[data-sort-select]');
        if (sort && !sort.form) {
          const url = new URL(window.location.href);
          url.searchParams.set('sort_by', sort.value);
          url.searchParams.delete('page');
          this.render(url.search.slice(1));
        }
      });
      document.addEventListener('click', (e) => {
        const link = e.target.closest('[data-facet-link]');
        if (link && link.href) {
          e.preventDefault();
          this.render(new URL(link.dataset.facetUrl || link.href, window.location.href).search.slice(1));
          return;
        }
        const more = e.target.closest('[data-facet-more]');
        if (more) {
          $$('.facet__more', more.closest('.facet__body')).forEach((li) => { li.hidden = false; });
          more.remove();
          return;
        }
        const open = e.target.closest('[data-filters-open]');
        if (open) { this.openDrawer(open); return; }
        if (e.target.closest('#FiltersDrawer [data-drawer-close]')) this.closeDrawer();
      });
      window.addEventListener('popstate', () => {
        if ($('[data-facets-form]') || $('[data-sort-select]')) this.render(window.location.search.slice(1), false);
      });
    },
    openDrawer(opener) {
      const d = $('#FiltersDrawer');
      if (!d || isDesktop()) return;
      this.opener = opener;
      d.classList.add('is-open');
      document.body.classList.add('has-overlay');
      opener.setAttribute('aria-expanded', 'true');
      this.release = trapFocus(d);
      this.onKey = (e) => { if (e.key === 'Escape') this.closeDrawer(); };
      document.addEventListener('keydown', this.onKey);
      const panel = $('.drawer__panel', d);
      if (!panel) return;
      // Sémantique de dialogue modal seulement quand le tiroir est ouvert (sur ordinateur, la colonne de filtres n'est pas un dialogue)
      panel.setAttribute('role', 'dialog');
      panel.setAttribute('aria-modal', 'true');
      panel.setAttribute('aria-label', d.getAttribute('aria-label') || S.filters || '');
      // Focus déplacé dans le tiroir une fois celui-ci visible (sinon il reste sur le bouton, derrière le voile)
      const focusIn = () => {
        if (!d.classList.contains('is-open') || d.contains(document.activeElement)) return;
        const first = $$('button, [href], input:not([type="hidden"]), select, summary, [tabindex]:not([tabindex="-1"])', panel).find((el) => !el.disabled && el.offsetParent !== null);
        (first || panel).focus();
      };
      requestAnimationFrame(() => requestAnimationFrame(focusIn));
      setTimeout(focusIn, 360);
    },
    closeDrawer() {
      const d = $('#FiltersDrawer');
      if (!d || !d.classList.contains('is-open')) return;
      d.classList.remove('is-open');
      document.body.classList.remove('has-overlay');
      const panel = $('.drawer__panel', d);
      if (panel) ['role', 'aria-modal', 'aria-label'].forEach((a) => panel.removeAttribute(a));
      if (this.release) this.release();
      document.removeEventListener('keydown', this.onKey);
      if (this.opener) { this.opener.setAttribute('aria-expanded', 'false'); this.opener.focus(); }
    },
    onFormChange: debounce(function (form) {
      const params = new URLSearchParams(new FormData(form));
      const sort = $('[data-sort-select]');
      if (sort && !params.has('sort_by')) params.set('sort_by', sort.value);
      Array.from(params.keys()).forEach((k) => { if (params.getAll(k).every((v) => v === '')) params.delete(k); });
      Facets.render(params.toString());
    }, 400),
    async render(search, push = true) {
      const host = $('[data-section-id]#CollectionSection, [data-section-id]#SearchSection');
      if (!host) { window.location.search = search; return; }
      const sectionId = host.dataset.sectionId;
      const grid = $('#ProductGridContainer');
      if (grid) grid.classList.add('is-loading');
      try {
        const res = await fetch(`${window.location.pathname}?${search}${search ? '&' : ''}section_id=${sectionId}`);
        const doc = parseHTML(await res.text());
        ['#ProductGridContainer', '#ProductCount', '#BrandBar'].forEach((sel) => {
          const fresh = $(sel, doc); const cur = $(sel);
          if (fresh && cur) cur.innerHTML = fresh.innerHTML;
        });
        const freshFacets = $('#FacetsWrapper', doc);
        const curFacets = $('#FacetsWrapper');
        if (freshFacets && curFacets) {
          const openStates = $$('details.facet', curFacets).map((d) => d.open);
          curFacets.innerHTML = freshFacets.innerHTML;
          $$('details.facet', curFacets).forEach((d, i) => { if (openStates[i] === false) d.open = false; });
        }
        const freshBtn = $('[data-filters-open]', doc); const curBtn = $('[data-filters-open]');
        if (freshBtn && curBtn) curBtn.innerHTML = freshBtn.innerHTML;
        if (push) window.history.pushState({}, '', `${window.location.pathname}${search ? '?' + search : ''}`);
        initWishlistButtons(document);
        stockFirst();
      } catch (err) {
        toast(S.network, 'error');
      } finally {
        if (grid) grid.classList.remove('is-loading');
      }
    }
  };
  Facets.init();

  class PriceRange extends HTMLElement {
    connectedCallback() {
      this.max = parseFloat(this.dataset.max) || 100;
      this.rMin = $('[data-range-min]', this); this.rMax = $('[data-range-max]', this);
      this.iMin = $('[data-input-min]', this); this.iMax = $('[data-input-max]', this);
      if (!this.rMin) return;
      const sync = (fromRange) => {
        let a = parseFloat(this.rMin.value); let b = parseFloat(this.rMax.value);
        if (a > b) [a, b] = [b, a];
        if (fromRange) { this.iMin.value = a > 0 ? a : ''; this.iMax.value = b < this.max ? b : ''; }
        this.style.setProperty('--from', `${(a / this.max) * 100}%`);
        this.style.setProperty('--to', `${(b / this.max) * 100}%`);
        const fill = $('.price-range__fill', this);
        if (fill) { fill.style.left = `${(a / this.max) * 100}%`; fill.style.right = `${100 - (b / this.max) * 100}%`; }
      };
      [this.rMin, this.rMax].forEach((r) => {
        r.addEventListener('input', () => sync(true));
        r.addEventListener('change', () => { sync(true); this.iMin.dispatchEvent(new Event('change', { bubbles: true })); });
      });
      [this.iMin, this.iMax].forEach((inp) => inp.addEventListener('input', () => {
        this.rMin.value = this.iMin.value || 0; this.rMax.value = this.iMax.value || this.max; sync(false);
      }));
      sync(false);
    }
  }
  customElements.define('price-range', PriceRange);

  /* ---------- « Charger plus » ---------- */
  // Les produits disponibles d'une page suivante passent avant les ruptures déjà affichées ; les ruptures restent à la fin
  const mergeItems = (grid, items) => {
    const firstSoldOut = $('#ProductGridContainer .product-grid > li[data-available="false"]');
    items.forEach((li) => {
      if (firstSoldOut && li.dataset.available !== 'false') grid.insertBefore(li, firstSoldOut);
      else grid.appendChild(li);
    });
  };
  const fetchPage = async (href, host) => {
    const url = new URL(href, window.location.origin);
    url.searchParams.set('section_id', host.dataset.sectionId);
    return parseHTML(await (await fetch(url)).text());
  };
  const swapWrap = (doc, wrap) => {
    const freshWrap = $('[data-load-more-wrap]', doc);
    if (wrap && freshWrap) wrap.replaceWith(freshWrap); else if (wrap) wrap.remove();
  };
  document.addEventListener('click', async (e) => {
    const btn = e.target.closest('[data-load-more]');
    if (!btn) return;
    const host = $('[data-section-id]#CollectionSection, [data-section-id]#SearchSection');
    if (!host) return;
    e.preventDefault();
    const grid = $('#ProductGridContainer .product-grid');
    if (grid && grid.dataset.stockFirst === 'loading') return;
    btn.classList.add('is-loading');
    try {
      const doc = await fetchPage(btn.href, host);
      const items = $$('#ProductGridContainer .product-grid > li', doc);
      const firstNew = items[0];
      mergeItems(grid, items);
      swapWrap(doc, btn.closest('[data-load-more-wrap]'));
      initWishlistButtons(grid);
      if (firstNew) { const link = $('.card-product__title a', firstNew) || $('a:not([tabindex="-1"])', firstNew); if (link) link.focus({ preventScroll: true }); }
    } catch (err) {
      window.location.href = btn.href;
    }
  });

  /* ---------- Stock d'abord sur toute la collection ---------- */
  // Chaque page n'est classée que pour elle-même (sections/main-collection.liquid) : quand la page affichée contient des
  // ruptures et qu'il reste des pages, les pages suivantes (jusqu'à 5 pages en tout) sont chargées tout de suite et leurs
  // produits disponibles passent avant les ruptures, sans attendre « Charger plus » (le tri choisi est conservé)
  const STOCK_FIRST_PAGES = 5;
  const stockFirst = async () => {
    const host = $('[data-section-id]#CollectionSection');
    const grid = $('#ProductGridContainer .product-grid');
    if (!host || !grid || grid.dataset.stockFirst) return;
    if (!$('#ProductGridContainer .product-grid > li[data-available="false"]')) return;
    grid.dataset.stockFirst = 'loading';
    let pages = 1;
    let btn = $('[data-load-more]', host);
    try {
      while (btn && btn.href && pages < STOCK_FIRST_PAGES) {
        btn.classList.add('is-loading');
        const doc = await fetchPage(btn.href, host);
        if (!grid.isConnected) return; // grille remplacée entre-temps (filtre, tri)
        mergeItems(grid, $$('#ProductGridContainer .product-grid > li', doc));
        swapWrap(doc, btn.closest('[data-load-more-wrap]'));
        pages += 1;
        btn = $('[data-load-more]', host);
      }
    } catch (err) {
      if (btn) btn.classList.remove('is-loading');
    } finally {
      grid.dataset.stockFirst = 'done';
      initWishlistButtons(grid);
    }
  };
  stockFirst();
  PL.stockFirst = stockFirst;

  /* ---------- Recherche : nombre de résultats de chaque onglet ---------- */
  const tabs = $('[data-search-tabs]');
  if (tabs && tabs.dataset.terms) {
    $$('[data-search-type]', tabs).forEach(async (el) => {
      if (el.textContent.trim()) return;
      try {
        const url = `${R.search}?q=${encodeURIComponent(tabs.dataset.terms)}&type=${el.dataset.searchType}&options%5Bprefix%5D=last&section_id=search-counts`;
        const count = $('[data-search-count]', parseHTML(await (await fetch(url)).text()));
        if (count) el.textContent = `(${count.textContent.trim()})`;
      } catch (err) { /* compteur facultatif */ }
    });
  }
})();
